import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const GlobalBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on login/signup pages or if there's no history
  const hideOnRoutes = ['/login', '/signup'];
  if (hideOnRoutes.includes(location.pathname)) {
    return null;
  }

  const handleBack = () => {
    // Go back in browser history
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // If no history, go to home
      navigate('/');
    }
  };

  return (
    <button
      onClick={handleBack}
      className="fixed top-4 left-4 z-[100] p-3 bg-gray-800/90 hover:bg-gray-700 rounded-full border border-gray-700 shadow-lg transition-all hover:scale-110 flex items-center justify-center group"
      aria-label="Go back"
      title="Go back to previous page"
    >
      <ArrowLeft 
        size={20} 
        className="text-gray-300 group-hover:text-white transition-colors" 
      />
    </button>
  );
};

export default GlobalBackButton;

